var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionConfirm = function SvgQuestionConfirm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.05 5a4.01 4.01 0 0 0-3.78 5.25.73.73 0 1 0 1.38-.47 2.53 2.53 0 0 1 2.4-3.32 2.53 2.53 0 0 1 2.41 3.32.73.73 0 1 0 1.38.47A4.01 4.01 0 0 0 12.05 5m0 2.9c-.6 0-1.09.5-1.09 1.1v7.02L8.9 14.97c-.41-.2-.9-.15-1.27.13-.55.43-.6 1.24-.1 1.74l3.52 3.52c.41.41.97.64 1.54.64h4.2c1.2 0 2.17-.98 2.17-2.18V15.3c0-.7-.5-1.3-1.18-1.43L13.15 13V9c0-.6-.5-1.1-1.1-1.1"
  })));
};
export default SvgQuestionConfirm;